import { v4 as uuidv4 } from "uuid";
import GiftFinderTemplate from "./assets/minisite/giftFinder";
import MagentoTemplate from "./assets/magento/base";
import Wordpress from "./wordpress";
import Facebook from "./facebook";
import EmailTemplate from "./email";
import MinisiteTemplate from "./assets/minisite/base";
import PresentationTemplate from "./presentation";
import BookTemplate from "./assets/book/homepage";
import GameTemplate from "./assets/game/base";
import CMSTemplate from "./assets/cms/base";
import { AssetTypes, ItemTypes, Pages } from "../shareable/types";
import { Toolbar } from "../shareable/tools";
import { getComponent } from "../core/components/assets";
import MinisiteContactEmail from '../../email/minisite/emailContact';
import FlipbookWinEmail from '../../email/flipbook/emailWin';
import FlipbookLooseEmail from '../../email/flipbook/emailLoose';
import GameEmail from "../../email/game/mailBase";

export const getTemplate = ( 
    asset, assetType, assetToken, page, preview = true, noPanel = false, droppable = null, // base
    config, apiConfig, // config
    updateConfig, inputCallback, deleteCallback, // methods
    taxes, onSnap, onStyle, pagesFlipbook,  // specific
    currentTab = 0, 
) => {
    const mapper = (element, index) => {
        return getComponent(
            element, index, 
            asset, assetType, assetToken, preview, droppable, 
            config, apiConfig, 
            updateConfig, inputCallback, deleteCallback, 
            taxes, onSnap, onStyle, pagesFlipbook,
            currentTab
        );
    };
    
    switch(assetType) {
        case AssetTypes.FLIPBOOK:
        case AssetTypes.NEWSLETTER:
            switch(page) {
                case Pages.HOMEPAGE_BOOK:
                case Pages.FLIPBOOK:
                case Pages.REGISTER_BOOK:
                case Pages.REGISTER_SUCCESS_BOOK:
                    return <BookTemplate
                        config={config[page]}
                        mapper={mapper}
                    />;
                case Pages.EMAIL_SUCCESS_BOOK:
                    let element = {
                        type: config[page].elements[0].type,
                        data: config[page].elements[0].data
                    };

                    return (
                        <div style={{ height: '100%' }}>
                            {
                                !preview  && <Toolbar 
                                    name={config[page].elements[0].data.name} 
                                    noBorder={true} 
                                    onEdit={() => inputCallback(Pages.EMAIL_SUCCESS_BOOK)} 
                                />
                            }
                            
                            { mapper(element, 0) }
                        </div>
                    );
                case Pages.EMAIL_WIN_BOOK:
                case Pages.EMAIL_WIN_BOOK_2:
                    return  <EmailTemplate name={config[page]?.elements[0]?.data.name} preview={preview} onEdit={() => inputCallback(ItemTypes.EMAIL_WIN_BOOK)}>
                                <FlipbookWinEmail data={config[page]?.elements[0]?.data} spread={true} key={page} id={uuidv4()} />
                            </EmailTemplate>;
                case Pages.EMAIL_LOOSE_BOOK:
                    return  <EmailTemplate name={config[page]?.elements[0]?.data.name} preview={preview} onEdit={() => inputCallback(ItemTypes.EMAIL_LOOSE_BOOK)}>
                                <FlipbookLooseEmail data={config[page]?.elements[0]?.data} spread={true} key={ItemTypes.EMAIL_LOOSE_BOOK} id={uuidv4()} />
                            </EmailTemplate>;
                default: return null;
            }
        case AssetTypes.GAME:
            switch (page) {
                case Pages.HOMEPAGE_GAME:
                case Pages.LOGIN_GAME:
                case Pages.INDEX_GAME:
                case Pages.GAME_GAME:
                case Pages.RESULTS_WIN_GAME:
                case Pages.RESULTS_LOOSE_GAME:
                case Pages.ALREADYPLAYED_GAME:
                case Pages.ALREADYWIN_GAME:
                case Pages.ALREADY_WIN_GAME:
                case Pages.ENDED_GAME:
                case Pages.NOT_STARTED_GAME:
                    return <GameTemplate 
                        config={config[page]} 
                        params={config.params} 
                        noPanel={noPanel} 
                        mapper={mapper} 
                        asset={asset} 
                        page={page} 
                    />;
                case Pages.EMAIL_CONFIRMATION_IG_GAME:
                case Pages.EMAIL_CONFIRMATION_RANDOM_GAME:
                case Pages.EMAIL_WIN_IG_GAME:
                case Pages.EMAIL_WIN_RANDOM_GAME:
                case Pages.EMAIL_SHARE_IG_GAME:
                    return  <EmailTemplate name={config[page]?.elements[0]?.data.name} preview={preview} onEdit={() => inputCallback(page)}>
                                <GameEmail data={config[page]?.elements[0]?.data} spread={true} key={page} id={uuidv4()} />
                            </EmailTemplate>;
                case Pages.EMAIL_SHARE_IG_GAME:
            }
        case AssetTypes.MINISITE:
            switch (page) {
                case Pages.HOME:
                case Pages.LANDING:
                case Pages.PRODUCT_DETAILS:
                case Pages.CONTACT:
                case Pages.WISHLIST:
                    return <MinisiteTemplate
                        config={config[page]}
                        apiConfig={apiConfig}
                        params={config.params}
                        preview={preview}
                        droppable={currentTab !== 3 ? droppable : false}
                        mapper={mapper}
                    />;
                case Pages.EMAIL_CONTACT:
                case Pages.EMAIL_WISHLIST:
                    return  <EmailTemplate name={config[page].data.name} preview={preview} onEdit={() => inputCallback(ItemTypes.EMAIL_CONTACT)}>
                                <MinisiteContactEmail data={config[page].data} spread={true} key={ItemTypes.EMAIL_CONTACT} id={uuidv4()} />
                            </EmailTemplate>;
            }
        case AssetTypes.LINKEDIN:
            if(AssetTypes.LINKEDIN === assetType) console.log(AssetTypes.LINKEDIN, assetType); else console.log('tets')
            return <Facebook
                config={config[page]}
                mapper={mapper}
            />;
        case AssetTypes.FACEBOOK:
            return <Facebook config={config[page]} mapper={mapper} />;
        // case AssetTypes.WORDPRESS:
        //     return <Wordpress config={config[page]} mapper={mapper} />;
        case AssetTypes.CMS:
            return <CMSTemplate
                config={config[page]}
                params={config.params}
                preview={preview}
                droppable={droppable}
                mapper={mapper}
            />;
        case AssetTypes.PAGES:
        case AssetTypes.MAGENTO:
        case AssetTypes.SHOPIFY:
        case AssetTypes.WORDPRESS:
            return <CMSTemplate
                config={config[page]}
                params={config.params}
                preview={preview}
                droppable={droppable}
                mapper={mapper}
            />;
        default:
            switch (page) {
                case Pages.MAGENTO:
                    return <MagentoTemplate
                        config={config[page]}
                        mapper={mapper}
                    />;
                case Pages.GIFT_FINDER:
                    return <GiftFinderTemplate
                        config={config[page]}
                        mapper={mapper}
                    />;
                case Pages.PRESENTATION:
                    return <PresentationTemplate
                        config={config[page]}
                        droppable={droppable}
                        mapper={mapper}
                    />;
            }
    }
};